// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // API key for google maps
  GOOGLE_MAPS_API_KEY: 'AIzaSyDTAnbYHkvbKFbYmWr10P918lcgqpwpDtk',
  // DOMAIN: `http://localhost:8000`,
  // IDENTITY: `http://localhost:8081`,
  // CORE: `http://localhost:8000`,


  DOMAIN: `https://api.onstak.io/services/va-platform`,
  IDENTITY: `https://api.onstak.io/services/identity`,  
  CORE: `https://api.onstak.io/services/iot-platform`,

  MERAKI: `https://api.meraki.com`,
  mode: 'local',
  ProjectName: 'va'

 


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
